import * as THREE from 'three';
import { Line2 } from 'three/examples/jsm/lines/Line2.js';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';

export function createCalloutLabel(scene, options = {}) {
  const {
    color = 0x52e0d0,
    textColor = '#52e0d0',
    leaderWidth = 2.2,
    offsetX = 82,
    offsetY = 56,
    renderOrder = 35,
  } = options;

  const canvas = document.createElement('canvas');
  canvas.width = 768;
  canvas.height = 192;

  const texture = new THREE.CanvasTexture(canvas);

  const label = new THREE.Sprite(
    new THREE.SpriteMaterial({
      map: texture,
      transparent: true,
      depthTest: false,
    })
  );

  label.visible = false;
  label.renderOrder = renderOrder;
  scene.add(label);

const leaderGeometry = new LineGeometry();

const leaderMaterial = new LineMaterial({
    color,
    linewidth: leaderWidth,
    worldUnits: false,
    depthTest: false,
    transparent: true,
    opacity: 0.95,
  });

const leader = new Line2(
    leaderGeometry,
    leaderMaterial
  );

  leader.visible = false;
  leader.renderOrder = renderOrder - 1;
  scene.add(leader);

const anchorPoint = new THREE.Mesh(
    new THREE.CircleGeometry(3, 20),
    new THREE.MeshBasicMaterial({
      color,
      depthTest: false,
    })
  );

  anchorPoint.visible = false;
  anchorPoint.renderOrder = renderOrder + 1;
  scene.add(anchorPoint);
    const labelPoint = new THREE.Mesh(
    new THREE.CircleGeometry(3, 20),
    new THREE.MeshBasicMaterial({
        color,
        depthTest: false,
    })
    );

    labelPoint.visible = false;
    labelPoint.renderOrder = renderOrder + 1;
    scene.add(labelPoint);

let currentAnchor = null;
let currentSide = 'left';
let currentVerticalSide = 'above';

function drawText(text, side = 'left') {
  const context =
    canvas.getContext('2d');

  context.clearRect(
    0,
    0,
    canvas.width,
    canvas.height
  );

  context.font =
    '700 64px system-ui';

  context.textBaseline =
    'middle';

  // Default:
  // text berada di kiri dan dot berada setelah karakter terakhir.
  //
  // Mirror:
  // dot berada sebelum karakter pertama dan text berada di kanan.
  const isLeft =
    side === 'left';

  const textX =
    isLeft ? 660 : 108;

  context.textAlign =
    isLeft ? 'right' : 'left';

  context.lineWidth = 6;

  context.strokeStyle =
    'rgba(0,0,0,.88)';

  context.strokeText(
    text,
    textX,
    100
  );

  context.fillStyle =
    textColor;

  context.fillText(
    text,
    textX,
    100
  );

  texture.needsUpdate = true;
}

function hide() {
    label.visible = false;
    leader.visible = false;
    anchorPoint.visible = false;
    labelPoint.visible = false;
    }
function resetPlacement() {
  currentSide = 'left';
  currentVerticalSide = 'above';
}
function dispose() {
    scene.remove(label);
    scene.remove(leader);
    scene.remove(anchorPoint);
    scene.remove(labelPoint);

    texture.dispose();
    label.material.dispose();

    leader.geometry.dispose();
    leader.material.dispose();

    anchorPoint.geometry.dispose();
    anchorPoint.material.dispose();
    labelPoint.geometry.dispose();
    labelPoint.material.dispose();
}
function updateLayout({
  text,
  target,
  unitsPerPixel,
  screenX,
  screenY,
  viewportWidth = 1,
  viewportHeight = 1,
}) {
  if (
    !text ||
    !target ||
    !Number.isFinite(unitsPerPixel) ||
    unitsPerPixel <= 0
  ) {
    hide();
    return;
  }

  const safeScreenX =
    Number.isFinite(screenX)
      ? screenX
      : viewportWidth / 2;

  const safeScreenY =
    Number.isFinite(screenY)
      ? screenY
      : viewportHeight / 2;

      const offscreenMarginPx = 48;
      const hideDistancePx = 420;

      const anchorOutsideX =
        safeScreenX < 0
          ? -safeScreenX
          : safeScreenX > viewportWidth
            ? safeScreenX - viewportWidth
            : 0;

      const anchorOutsideY =
        safeScreenY < 0
          ? -safeScreenY
          : safeScreenY > viewportHeight
            ? safeScreenY - viewportHeight
            : 0;

      const anchorOutsideDistance =
        Math.hypot(
          anchorOutsideX,
          anchorOutsideY
        );

      if (
        anchorOutsideDistance >
        hideDistancePx
      ) {
        hide();
        return;
      }
      const leaderTargetScreenX =
        Math.max(
          -offscreenMarginPx,
          Math.min(
            viewportWidth + offscreenMarginPx,
            safeScreenX
    )
  );

const leaderTargetScreenY =
  Math.max(
    -offscreenMarginPx,
    Math.min(
      viewportHeight + offscreenMarginPx,
      safeScreenY
    )
  );
  // --------------------------------
  // Callout layout constants (pixels)
  // --------------------------------

  const labelWidthPx = 220;
  const labelHeightPx = 54;

  // Ukur lebar TEXT aktual,
  // bukan seluruh canvas/sprite.
  const measureContext =
    canvas.getContext('2d');

  measureContext.font =
    '700 64px system-ui';

  const textWidthCanvasPx =
    measureContext.measureText(text).width;

  // Konversi ukuran text canvas
  // ke ukuran visual sprite di layar.
  const textWidthScreenPx =
    (textWidthCanvasPx / canvas.width) *
    labelWidthPx;

  // Sedikit ruang untuk dot + gap.
  const labelContentWidthPx =
    Math.max(
      44,
      textWidthScreenPx + 22
    );

  const labelHalfWidthPx =
    labelContentWidthPx / 2;

  const labelHalfHeightPx =
    labelHeightPx / 2;

  const marginPx = 16;
  // Jarak anchor ke dot di sisi label.
  const connectorGapXPx = 92;
  const connectorGapYPx = 112;

  // Short segment:
  // label dot -> elbow.
  const shortXPx = 32;
  const shortYPx = 16;

  // Posisi dot pada canvas sprite.
  const connectorCanvasLeft = 686;
  const connectorCanvasRight = 82;

  const connectorOffsetLeftPx =
    ((connectorCanvasLeft - 384) / 768) *
    labelWidthPx;

  const connectorOffsetRightPx =
    ((connectorCanvasRight - 384) / 768) *
    labelWidthPx;


  let side = currentSide;
  let verticalSide = currentVerticalSide;

  // Coba posisi default LEFT.
  let connectorScreenX =
    safeScreenX - connectorGapXPx;

  let connectorScreenY =
    safeScreenY - connectorGapYPx;

  let connectorCanvasOffsetPx =
    connectorOffsetLeftPx;

  let labelScreenX =
    connectorScreenX -
    connectorCanvasOffsetPx;

  let labelScreenY =
    connectorScreenY;
  // --------------------------------
  // Horizontal mirror
  // --------------------------------

  const mirrorHysteresisPx = 36;

const preferredLeftConnectorX =
  safeScreenX - connectorGapXPx;

const preferredLeftLabelX =
  preferredLeftConnectorX -
  connectorOffsetLeftPx;

const preferredLeftEdge =
  preferredLeftLabelX -
  labelHalfWidthPx;

const preferredRightConnectorX =
  safeScreenX + connectorGapXPx;

const preferredRightLabelX =
  preferredRightConnectorX -
  connectorOffsetRightPx;

const preferredRightEdge =
  preferredRightLabelX +
  labelHalfWidthPx;

if (
  currentSide === 'left' &&
  preferredLeftEdge <
    marginPx
) {
  currentSide = 'right';
} else if (
  currentSide === 'right' &&
  preferredLeftEdge >
    marginPx +
      mirrorHysteresisPx
) {
  currentSide = 'left';
}

side = currentSide;

if (side === 'left') {
  connectorScreenX =
    preferredLeftConnectorX;

  connectorCanvasOffsetPx =
    connectorOffsetLeftPx;

  labelScreenX =
    preferredLeftLabelX;
} else {
  connectorScreenX =
    preferredRightConnectorX;

  connectorCanvasOffsetPx =
    connectorOffsetRightPx;

  labelScreenX =
    preferredRightLabelX;
}

  // --------------------------------
  // Vertical mirror
  // --------------------------------

  const mirrorVerticalHysteresisPx = 36;

  const preferredAboveY =
    safeScreenY -
    connectorGapYPx;

  const preferredAboveTop =
    preferredAboveY -
    labelHalfHeightPx;

  if (
    currentVerticalSide === 'above' &&
    preferredAboveTop <
      marginPx
  ) {
    currentVerticalSide =
      'below';
  } else if (
    currentVerticalSide === 'below' &&
    preferredAboveTop >
      marginPx +
        mirrorVerticalHysteresisPx
  ) {
    currentVerticalSide =
      'above';
  }

  verticalSide =
    currentVerticalSide;

  if (verticalSide === 'above') {
    connectorScreenY =
      safeScreenY -
      connectorGapYPx;
  } else {
    connectorScreenY =
      safeScreenY +
      connectorGapYPx;
  }

  labelScreenY =
    connectorScreenY;

  // --------------------------------
  // Last-resort viewport clamp
  // --------------------------------

  labelScreenX =
    Math.max(
      marginPx + labelHalfWidthPx,
      Math.min(
        viewportWidth -
          marginPx -
          labelHalfWidthPx,
        labelScreenX
      )
    );

  labelScreenY =
    Math.max(
      marginPx + labelHalfHeightPx,
      Math.min(
        viewportHeight -
          marginPx -
          labelHalfHeightPx,
        labelScreenY
      )
    );

  // Karena clamp bisa menggeser sprite,
  // hitung ulang posisi connector dari sprite.

  connectorScreenX =
    labelScreenX +
    connectorCanvasOffsetPx;

  connectorScreenY =
    labelScreenY;

  // --------------------------------
  // Draw text with correct mirror
  // --------------------------------

  drawText(
    text,
    side
  );

  // --------------------------------
  // Convert screen offsets -> world
  // --------------------------------

  const screenToWorld = (
    x,
    y
  ) =>
    new THREE.Vector3(
      target.x +
        (x - safeScreenX) *
        unitsPerPixel,

      target.y +
        (safeScreenY - y) *
        unitsPerPixel,

      target.z
    );
  const leaderTarget =
    screenToWorld(
      leaderTargetScreenX,
      leaderTargetScreenY
    );
  const labelPosition =
    screenToWorld(
      labelScreenX,
      labelScreenY
    );

  const connectorPoint =
    screenToWorld(
      connectorScreenX,
      connectorScreenY
    );

  // --------------------------------
  // Elbow
  // --------------------------------

  // Dari label menuju anchor:
  // LEFT placement -> short segment ke kanan.
  // RIGHT placement -> mirror ke kiri.

  const horizontalDirection =
    side === 'left'
      ? 1
      : -1;

  // ABOVE -> short segment turun.
  // BELOW -> short segment naik.

  const verticalDirection =
    verticalSide === 'above'
      ? 1
      : -1;

  const elbowScreenX =
    connectorScreenX +
    shortXPx *
      horizontalDirection;

  const elbowScreenY =
    connectorScreenY +
    shortYPx *
      verticalDirection;

  const elbowPoint =
    screenToWorld(
      elbowScreenX,
      elbowScreenY
    );

  // --------------------------------
  // Update Three.js objects
  // --------------------------------

  label.position.copy(
    labelPosition
  );

  labelPoint.position.copy(
    connectorPoint
  );

  anchorPoint.position.copy(
    leaderTarget
  );

  leader.geometry.dispose();

  const geometry =
    new LineGeometry();

geometry.setPositions([
  leaderTarget.x,
  leaderTarget.y,
  leaderTarget.z,

  elbowPoint.x,
  elbowPoint.y,
  elbowPoint.z,

  connectorPoint.x,
  connectorPoint.y,
  connectorPoint.z,
]);

  leader.geometry =
    geometry;

  leader.computeLineDistances();

  leaderMaterial.resolution.set(
    viewportWidth,
    viewportHeight
  );

  label.visible = true;
  leader.visible = true;
  anchorPoint.visible = true;
  labelPoint.visible = true;
}
return {
    canvas,
    texture,
    label,
    leader,
    anchorPoint,
    labelPoint,
    leaderMaterial,

    drawText,
    updateLayout,
    hide,
    resetPlacement,
    dispose,
    

    get offsetX() {
        return offsetX;
    },

    get offsetY() {
        return offsetY;
    },

    get anchor() {
      return currentAnchor;
    },

    setAnchor(value) {
      currentAnchor = value;
    },
  };
}
